import {
    SPARE_PARTS_ORDERS_STATISTICS_SEND,
    SPARE_PARTS_ORDERS_STATISTICS_SEND_ERROR
} from '../../constants/websocketCommands';
import {SPARE_PARTS_ORDERS_STATISTICS_PENDING} from '../../actions/orders/actionSparePartsStatistics';

export const sparePartsStatistics = (state = {
    correlationId: '',
    isLoading: false,
    data: [],
}, action) => {
    switch (action.type) {
        case SPARE_PARTS_ORDERS_STATISTICS_PENDING: {
            const { correlationId } = action.payload;
            return Object.assign({}, state, {
                isLoading: true, correlationId
            });
        }
        case SPARE_PARTS_ORDERS_STATISTICS_SEND: {
            const { correlationId, result: { data } } = action.payload;
            if (correlationId !== state.correlationId) {
                return state;
            } else {
                return Object.assign({}, state, {
                    isLoading: false, correlationId, data
                });
            }
        }
        case SPARE_PARTS_ORDERS_STATISTICS_SEND_ERROR: {
            const { correlationId } = action.payload;
            if (correlationId !== state.correlationId) {
                return state;
            } else {
                return Object.assign({}, state, {
                    isLoading: false, correlationId
                });
            }
        }
        default: {
            return state;
        }
    }
};
